import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { ChatEntryPoint } from "@data-types/chat";
import classNames from "classnames";
import { ChatSportIcon } from "../shared";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function ChannelSportsHeader() {
	const { chatViewStore } = useRootAppStore();

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Mobile/ChannelSportsHeader.tsx"}
		>
			<nav className="chat__nav">
				{chatViewStore?.chatListHandler?.channelList.map((channel) => (
					<button
						className={classNames(
							"chat__nav__btn btn btn--icon btn--ghost",
							{
								"is-active":
									channel.channelId ===
									chatViewStore.chatChannelHandler
										.activeChannelInfo?.channelId,
							}
						)}
						key={channel.channelId}
						onClick={async () => {
							await chatViewStore.onInitialize(
								ChatEntryPoint.LIST,
								{
									channelId: channel.channelId,
									displayName: channel.displayName,
									sportAbrv: channel.sportAbrv,
									categoryAbrv: channel.categoryAbrv,
									tournamentAbrv: channel.tournamentAbrv,
								}
							);
						}}
						disabled={chatViewStore.replyScrollingLoader}
					>
						{/* in case if channel does not have sport abrv, using multi icon - same as fallback image but with monochrome option */}
						<ChatSportIcon
							sportAbrv={channel.sportAbrv || "multi"}
							iconClassName={"u-icon u-icon--big"}
							isActive={
								channel.channelId ==
								chatViewStore.chatChannelHandler
									.activeChannelInfo?.channelId
							}
						/>
					</button>
				))}
			</nav>
		</ErrorBoundaryWithPropagation>
	);
});
